import { Component, ChangeDetectorRef, OnInit, OnDestroy } from '@angular/core';
import { animate, AUTO_STYLE, state, style, transition, trigger } from '@angular/animations';
import { Subscription } from 'rxjs/Subscription';
import { MenuItem } from 'primeng/api';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {environment} from '../environments/environment';
import { saveAs } from 'file-saver';
import {GenerateExcelService} from './services/generate-excel.service';
import {GenerateXmlService} from './services/generate-xml.service';

import {SelectCountryComponent} from './select-country/select-country.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [
    trigger('notificationBottom', [
      state('an-off, void',
        style({
          overflow: 'hidden',
          height: '0px',
        })
      ),
      state('an-animate',
        style({
          overflow: 'visible',
          height: AUTO_STYLE,
        })
      ),
      transition('an-off <=> an-animate', [
        animate('400ms ease-in-out')
      ])
    ]),
    trigger('slideInOut', [
      state('in', style({
        width: '280px',
        // transform: 'translate3d(0, 0, 0)'
      })),
      state('out', style({
        width: '0',
        // transform: 'translate3d(100%, 0, 0)'
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('400ms ease-in-out'))
    ]),
    trigger('mobileHeaderNavRight', [
      state('nav-off, void',
        style({
          overflow: 'hidden',
          height: '0px',
        })
      ),
      state('nav-on',
        style({
          height: AUTO_STYLE,
        })
      ),
      transition('nav-off <=> nav-on', [
        animate('400ms ease-in-out')
      ])
    ]),
    trigger('fadeInOutTranslate', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('400ms ease-in-out', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        style({ transform: 'translate(0)' }),
        animate('400ms ease-in-out', style({ opacity: 0 }))
      ])
    ]),
    trigger('mobileMenuTop', [
      state('no-block, void',
        style({
          overflow: 'hidden',
          height: '0px',
        })
      ),
      state('yes-block',
        style({
          height: AUTO_STYLE,
        })
      ),
      transition('no-block <=> yes-block', [
        animate('400ms ease-in-out')
      ])
    ])
  ]
})
export class AppComponent implements OnInit, OnDestroy {
  public animateSidebar: string;
  public navType: string;
  public themeLayout: string;
  public verticalPlacement: string;
  public verticalLayout: string;
  public pcodedDeviceType: string;
  public verticalNavType: string;
  public verticalEffect: string;
  public vnavigationView: string;
  public freamType: string;
  public sidebarImg: string;
  public sidebarImgType: string;
  public layoutType: string;

  public headerTheme: string;
  public pcodedHeaderPosition: string;

  public liveNotification: string;
  public liveNotificationClass: string;

  public profileNotification: string;
  public profileNotificationClass: string;

  public chatSlideInOut: string;
  public innerChatSlideInOut: string;

  public searchWidth: number;
  public searchWidthString: string;

  public navRight: string;
  public windowWidth: number;
  public chatTopPosition: string;

  public toggleOn: boolean;
  public toggleIcon: string;
  public navBarTheme: string;
  public activeItemTheme: string;
  public pcodedSidebarPosition: string;

  public headerFixedTop: string;

  public menuTitleTheme: string;
  public dropDownIcon: string;
  public subItemIcon: string;

  public configOpenRightBar: string;
  public displayBoxLayout: string;
  public isVerticalLayoutChecked: boolean;
  public isSidebarChecked: boolean;
  public isHeaderChecked: boolean;
  public headerFixedMargin: string;
  public sidebarFixedHeight: string;
  public sidebarFixedNavHeight: string;
  public itemBorderStyle: string;
  public subItemBorder: boolean;
  public itemBorder: boolean;

  public isCollapsedSideBar: string;
  public psDisabled: string;
  public perfectDisable: string;

  public config: any;

  public currentUserName = 'Unknow User';
  public currentFullName = '';
  public isAuthenticated: boolean;
  public items: MenuItem[];

  // //** options for notify start */
  public options: any = {
    position: ['bottom', 'right'],
  };
  // //** options for notify end */

  // show loader
  public loaderSubscription: Subscription;

  // By id
  public intervalId;
  public refernceId;
  public entities: any;
  public sampleData: any;
  public sampleOptions: any;
  public language = 'English';
  public spokenSpeakerList = [];
  public futureSpeakerList = [];
  public dataLink = environment.dataUrl;
public env=environment.env;
  public headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0', 'Pragma': 'no-cache', 'Expires': '0'
  });

  public categoryList = [
    {
      key: 0,
      value: '(Please select)'
    },
    {
      key: -1,
      value: 'United Nations Protocol and Liaison Service'
    },
    {
      key: 1,
      value: 'Member States maintaining permanent missions at Headquarters'
    },
    {
      key: 2,
      value: `Non-member States having received a standing invitation to participate
      as observers in the sessions and the work of the General Assembly and maintaining permanent offices at Headquarters`
    },
    {
      key: 4,
      value: `Intergovernmental organizations having received a standing invitation to participate as observers in the sessions and
      the work of the General Assembly and maintaining permanent offices at Headquarters`
    },
    {
      key: 5,
      value: `Other entities having received a standing invitation to participate as observers in the sessions and the work of the
      General Assembly and maintaining permanent offices at Headquarters`
    },
    {
      key: 6,
      value: 'Specialized agencies and related organizations maintaining liaison office at Headquarters'
    },
    {
      key: 10,
      value: 'National holidays of Member States'
    }
  ];
  public category = {
    key: 0,
    value: '(Please select)'
  };

  public missionList = [];

  public mission = {};

  public splittedData = {
    country: {
      '1': [],
      '2': [],
      '4': [],
      '5': [],
      '6': []
    },
    bluebook: []
  };

  public representativeList = [];
  public representativeListExcel = [];

  public holiday = {
    January: {},
    February: {},
    March: {},
    April: {},
    May: {},
    June: {},
    July: {},
    August: {},
    September: {},
    October: {},
    November: {},
    December: {}
  };

  public holidayList = [
    {
      month: 'January',
      dates: []
    },
    {
      month: 'February',
      dates: []
    },
    {
      month: 'March',
      dates: []
    },
    {
      month: 'April',
      dates: []
    },
    {
      month: 'May',
      dates: []
    },
    {
      month: 'June',
      dates: []
    },
    {
      month: 'July',
      dates: []
    },
    {
      month: 'August',
      dates: []
    },
    {
      month: 'September',
      dates: []
    },
    {
      month: 'October',
      dates: []
    },
    {
      month: 'November',
      dates: []
    },
    {
      month: 'December',
      dates: []
    }
  ];

  public generalInfo = {};

  public staffList = [];

  public showDetail = false;

  public showHoliday = false;

  public viewPrint = false;

  public printDate = null;

  public showService = false;

  constructor(public cdr: ChangeDetectorRef,
    public http: HttpClient, public generateExcelService:GenerateExcelService,
    public modal:NgbModal, public generateXmlService:GenerateXmlService) {

    this.animateSidebar = '';
    this.navType = 'st2';
    this.themeLayout = 'horizontal';
    this.verticalPlacement = 'top';
    this.verticalLayout = 'wide';
    this.pcodedDeviceType = 'desktop';
    this.verticalNavType = 'expanded';
    this.verticalEffect = 'shrink';
    this.vnavigationView = 'view1';
    this.freamType = 'theme1';
    this.sidebarImg = 'false';
    this.sidebarImgType = 'img1';
    this.layoutType = 'light'; // light(default) dark(dark)

    this.headerTheme = 'theme1'; // theme1(default)
    this.pcodedHeaderPosition = 'fixed';

    this.headerFixedTop = 'auto';

    this.liveNotification = 'an-off';
    this.profileNotification = 'an-off';

    this.chatSlideInOut = 'out';
    this.innerChatSlideInOut = 'out';

    this.searchWidth = 0;

    this.navRight = 'nav-on';

    this.windowWidth = window.innerWidth;
    this.setHeaderAttributes(this.windowWidth);

    this.toggleOn = true;
    this.toggleIcon = 'icon-toggle-right';
    this.navBarTheme = 'themelight1'; // themelight1(default) theme1(dark)
    this.activeItemTheme = 'theme1';
    this.pcodedSidebarPosition = 'fixed';
    this.menuTitleTheme = 'theme1'; // theme1(default) theme10(dark)
    this.dropDownIcon = 'style1';
    this.subItemIcon = 'style1';

    this.displayBoxLayout = 'd-none';
    this.isVerticalLayoutChecked = false;
    this.isSidebarChecked = true;
    this.isHeaderChecked = true;
    this.headerFixedMargin = '0px'; // 50px
    this.sidebarFixedHeight = '100%'; // calc(100vh - 190px)
    this.itemBorderStyle = 'none';
    this.subItemBorder = true;
    this.itemBorder = true;

    this.isCollapsedSideBar = 'no-block';

    this.perfectDisable = '';

    this.setMenuAttributes(this.windowWidth);
    this.setHeaderAttributes(this.windowWidth);
  }

  ngOnInit() {
    this.setBackgroundPattern('theme1');
    /*document.querySelector('body').classList.remove('dark');*/
    console.log('AppComponent: Checking if the user is already authenticated');

    this.items = [
      { label: 'Español', command: () => this.setupLanguage('Español') },
      { label: 'Русский', command: () => this.setupLanguage('Русский') },
      { label: 'Français', command: () => this.setupLanguage('Français') },
      { label: 'English', command: () => this.setupLanguage('English') },
      { label: '中文', command: () => this.setupLanguage('中文') },
      { label: 'العربية', command: () => this.setupLanguage('العربية') },
    ];
    console.log(this.dataLink);

    this.loadData();
  }

  changeCategory() {
    this.showService = false;
    this.showDetail = false;
    this.showHoliday = false;
    this.missionList = [];
    this.mission = {};

    if ([1, 2, 4, 5, 6].indexOf(this.category.key) !== -1) {
      this.missionList = this.splittedData.country[this.category.key];
    } else if (this.category.key === 10) {
      this.showHoliday = true;
    } else if (this.category.key === -1) {
      this.showService = true;
    }
    console.log(this.missionList);
  }


  changeMissionExcel(mission,category){
    this.representativeListExcel = [];

    const l = this.splittedData.bluebook.map(i => i['BB_Mission']).indexOf(mission['MC_Entity']);
    const r = this.splittedData.bluebook.map(i => i['BB_Mission']).lastIndexOf(mission['MC_Entity']);

    this.representativeListExcel = this.splittedData.bluebook.slice(l, r + 1);
    this.representativeListExcel.forEach(delegateBB=>{
      if(delegateBB["BB_Dipl_Rank_Display"]==""){
        if(delegateBB["BB_Dipl_Rank"]==""){
          delegateBB["BB_Dipl_Rank_Display"]="(no dipl rank)";
        }
        else{
          delegateBB["BB_Dipl_Rank_Display"]=delegateBB["BB_Dipl_Rank"];
        
        }
      }
     
    })
    
    this.representativeListExcel.sort((a, b) => {
      // if (!a['BB_Dipl_Rank'] && !b['BB_Dipl_Rank']) {
      //   return a['BB_LastName'].localeCompare(b['BB_LastName']);
      // } else if (!a['BB_Dipl_Rank']) {
      //     return 1;
      // } else if (!b['BB_Dipl_Rank']) {
      //   return -1;
      // } else {
        
      //   if (a['BB_Dipl_Rank'] === b['BB_Dipl_Rank']) {
      //     return this.checkOrder(a['BB_Function']) - this.checkOrder(b['BB_Function']);
      //   } else {

      //     return this.checkOrder(a['BB_Dipl_Rank_Display']) - this.checkOrder(b['BB_Dipl_Rank_Display']);
      //   }
      // }
      const rank=  this.checkOrder(a['BB_Dipl_Rank_Display']) - this.checkOrder(b['BB_Dipl_Rank_Display']);
const position=a.BB_Position-b.BB_Position;
return rank||position;

    });

    if (category === 1 &&
      (this.representativeListExcel.length === 0 || (this.representativeListExcel[0]['BB_Function'] !== 'Permanent Representative' ))) {
          this.representativeListExcel.unshift({
          BB_Dipl_Rank: 'Ambassador Extraordinary and Plenipotentiary',
          BB_FirstName: '',
          BB_Function: 'Permanent Representative (DPC: ...)',
          BB_LastName: '',
          BB_PhnNumber: '',
          BB_Spouse: '',
          BB_Title: 'H.E. ...',
          BB_Cred_Presented: '',
          BB_Email: ''
        });
      }

    if ([2, 4, 5].indexOf(category) !== -1 &&
      (this.representativeListExcel.length === 0 ||
      (this.representativeListExcel[0]['BB_Function'] !== 'Permanent Observer' &&
      this.representativeListExcel[0]['BB_Dipl_Rank'] !== 'Permanent Observer' &&
      this.representativeListExcel[0]['BB_Dipl_Rank_Display'] !== 'Permanent Observer' &&
      this.representativeListExcel[0]['BB_Dipl_Rank'] !== 'Ambassador Extraordinary and Plenipotentiary'))) {
        this.representativeListExcel.unshift({
          BB_Dipl_Rank: '',
          BB_FirstName: '',
          BB_Function: 'Permanent Observer',
          BB_LastName: '',
          BB_PhnNumber: '',
          BB_Spouse: '',
          BB_Title: '...',
          BB_Cred_Presented: '',
          BB_Email: ''
        });
      }
      if (category == 6 &&
      (this.representativeListExcel.length === 0 ||
      (this.representativeListExcel[0]['BB_Function'] !== 'Permanent Observer' &&
      this.representativeListExcel[0]['BB_Dipl_Rank'] !== 'Permanent Observer' &&
      this.representativeListExcel[0]['BB_Dipl_Rank_Display'] !== 'Permanent Observer' &&
      this.representativeListExcel[0]['BB_Dipl_Rank'] !== 'Ambassador Extraordinary and Plenipotentiary'))) {
        this.representativeListExcel.unshift({
          BB_Dipl_Rank: '',
          BB_FirstName: '',
          BB_Function: '',
          BB_LastName: '',
          BB_PhnNumber: '',
          BB_Spouse: '',
          BB_Title: '...',
          BB_Cred_Presented: '',
          BB_Email: ''
        });
      }

   
  }
  changeMission() {
    this.showDetail = false;
    this.representativeList = [];

    const l = this.splittedData.bluebook.map(i => i['BB_Mission']).indexOf(this.mission['MC_Entity']);
    const r = this.splittedData.bluebook.map(i => i['BB_Mission']).lastIndexOf(this.mission['MC_Entity']);

    this.representativeList = this.splittedData.bluebook.slice(l, r + 1);
    this.representativeList.forEach(delegateBB=>{
      if(delegateBB["BB_Dipl_Rank_Display"]==""){
        if(delegateBB["BB_Dipl_Rank"]==""){
          delegateBB["BB_Dipl_Rank_Display"]="(no dipl rank)";
        }
        else{
          delegateBB["BB_Dipl_Rank_Display"]=delegateBB["BB_Dipl_Rank"];
        
        }
      }
     
    })
    
    this.representativeList.sort((a, b) => {
      // if (!a['BB_Dipl_Rank'] && !b['BB_Dipl_Rank']) {
      //   return a['BB_LastName'].localeCompare(b['BB_LastName']);
      // } else if (!a['BB_Dipl_Rank']) {
      //     return 1;
      // } else if (!b['BB_Dipl_Rank']) {
      //   return -1;
      // } else {
        
      //   if (a['BB_Dipl_Rank'] === b['BB_Dipl_Rank']) {
      //     return this.checkOrder(a['BB_Function']) - this.checkOrder(b['BB_Function']);
      //   } else {

      //     return this.checkOrder(a['BB_Dipl_Rank_Display']) - this.checkOrder(b['BB_Dipl_Rank_Display']);
      //   }
      // }
      const rank=  this.checkOrder(a['BB_Dipl_Rank_Display']) - this.checkOrder(b['BB_Dipl_Rank_Display']);
const position=a.BB_Position-b.BB_Position;
return rank||position;

    });

    if (this.category.key === 1 &&
      (this.representativeList.length === 0 ||  (this.representativeList[0]['BB_Function'] !== 'Permanent Representative'))) {
        this.representativeList.unshift({
          BB_Dipl_Rank: 'Ambassador Extraordinary and Plenipotentiary',
          BB_FirstName: '',
          BB_Function: 'Permanent Representative (DPC: ...)',
          BB_LastName: '',
          BB_PhnNumber: '',
          BB_Spouse: '',
          BB_Title: 'H.E. ...',
          BB_Cred_Presented: '',
          BB_Email: ''
        });
      }

    if ([2, 4, 5].indexOf(this.category.key) !== -1 &&
      (this.representativeList.length === 0 ||
      (this.representativeList[0]['BB_Function'] !== 'Permanent Observer' &&
       this.representativeList[0]['BB_Dipl_Rank'] !== 'Permanent Observer' &&
       this.representativeList[0]['BB_Dipl_Rank_Display'] !== 'Permanent Observer' &&
       this.representativeList[0]['BB_Dipl_Rank'] !== 'Ambassador Extraordinary and Plenipotentiary'))) {
        this.representativeList.unshift({
          BB_Dipl_Rank: '',
          BB_FirstName: '',
          BB_Function: 'Permanent Observer',
          BB_LastName: '',
          BB_PhnNumber: '',
          BB_Spouse: '',
          BB_Title: '...',
          BB_Cred_Presented: '',
          BB_Email: ''
        });
      }
      if (this.category.key == 6 &&
      (this.representativeList.length === 0 ||
      (this.representativeList[0]['BB_Function'] !== 'Permanent Observer' &&
       this.representativeList[0]['BB_Dipl_Rank'] !== 'Permanent Observer' &&
       this.representativeList[0]['BB_Dipl_Rank_Display'] !== 'Permanent Observer' &&
       this.representativeList[0]['BB_Dipl_Rank'] !== 'Ambassador Extraordinary and Plenipotentiary'))) {
        this.representativeList.unshift({
          BB_Dipl_Rank: '',
          BB_FirstName: '',
          BB_Function: '',
          BB_LastName: '',
          BB_PhnNumber: '',
          BB_Spouse: '',
          BB_Title: '...',
          BB_Cred_Presented: '',
          BB_Email: ''
        });
      }

    this.showDetail = true;
console.log(this.splittedData);
    console.log(this.representativeList);
  }

  checkOrder(rank) {
    switch (rank) {
      case 'Ambassador Extraordinary and Plenipotentiary':
        return 0;
      case 'Apostolic Nuncio':
        return 1;
      case 'Permanent Observer':
        return 2;
      case 'Ambassador':
        return 3;
      case 'Envoy Extraordinary and Minister Plenipotentiary':
        return 4;
      case 'Minister Plenipotentiary':
        return 5;
      case 'Minister':
        return 6;
      case 'Minister Counsellor':
        return 7;
      case 'Senior Counsellor':
        return 8;
      case 'First Counsellor':
        return 9;
      case 'Second Counsellor':
        return 10;
      case 'Third Counsellor':
        return 11;
      case 'Fourth Counsellor':
        return 12;
      case 'Fifth Counsellor':
        return 13;
      case 'Counsellor':
        return 14;
      case 'Deputy Counsellor':
        return 15;
      case 'First Secretary':
        return 16;
      case 'Second Secretary':
        return 17;
      case 'Third Secretary':
        return 18;
      case 'Attaché':
        return 19;
      case 'Assistant Attaché':
        return 20;
      case 'Senior Adviser':
        return 21;
      case 'Adviser':
        return 22;
      case '(no dipl rank)':
        return 23;
      case 'Administrative section':
        return 24;
      case 'Legal section':
        return 25;
      case 'Military section':
        return 26;
      case 'Military support section':
        return 27;
      case 'Press Section':
        return 28;
      case `Don't exceed this numbe`:
        return 29;
      default:
        return 100;
    }
  }

  checkFirst(index) {
    if (index === 0) {
      return {
        'border-bottom': '1px solid black',
        'padding-bottom': '1%',
        'margin-bottom': '1%'
      };
    }
  }

  loadData() {
    let data = {};

    this.http.get(this.dataLink, { headers: this.headers }).subscribe(
      res => {
        data = res;

        // get pls general info
        this.generalInfo = data['plsGeneralInfo'][0];

        // get pls staff
        this.staffList = data['plsStaff'];
        this.staffList=this.staffList.sort((a,b)=>{
         return a.LKP_WebsiteOrder-b.LKP_WebsiteOrder;
        })
        console.log(this.staffList);

        // split countries by category
        data['countries'].forEach(i => {
          if (this.splittedData.country.hasOwnProperty(i.MC_Category)) {
            this.splittedData.country[i.MC_Category].push(i);
          }
          // fatch holiday
          for (const month in this.holiday) {
            if (this.holiday.hasOwnProperty(month)) {
              if (i['MC_Holiday'].indexOf(month) !== -1) {
                for (const j of i['MC_Holiday'].split(' ')) {
                  if (j && !isNaN(j)) {
                    if (this.holiday[month].hasOwnProperty(j)) {
                      this.holiday[month][j].push(i['MC_EntityShort']);
                    } else {
                      this.holiday[month][j] = [i['MC_EntityShort']];
                    }
                  }
                }
              }
            }
          }
        });

        // put into holidayList
        for (const month of this.holidayList) {
          for (const date in this.holiday[month['month']]) {
            if (this.holiday[month['month']].hasOwnProperty(date)) {
              month['dates'].push({
                date: parseInt(date, 10),
                countries: this.holiday[month['month']][date].sort((a, b) => {
                  return a.localeCompare(b);
                })
              });
            }
          }
          month.dates.sort((a, b) => {
            return a['date'] - b['date'];
          });
        }

        // get blue book
        this.splittedData.bluebook = data['bluebooks'];

        // sort each category
        for (const i in this.splittedData.country) {
          if (this.splittedData.country.hasOwnProperty(i)) {
            this.splittedData.country[i].sort((a, b) => {
              return a['MC_Entity'].localeCompare(b['MC_Entity']);
            });
          }
        }

        // sort blue book
        this.splittedData.bluebook.sort((a, b) => {
          return a['BB_Mission'].localeCompare(b['BB_Mission']);
        });
      }
    );
  }

  goPrint() {
    this.printDate = new Date();
    this.viewPrint = true;
  }

  goBack() {
    this.viewPrint = false;
  }

  print() {
    window.print();
  }

  setViewOptions(speakerList, options) {
    options.forEach(option => {
      speakerList.forEach(speaker => {
        if (speaker._id === option.id) {
          speaker['MT_speakers'].forEach(mt_speaker => {
            mt_speaker.LS_PublicOption = option.LS_PublicOption;
          });
        }
      });
    });
  }

  segregateSpeakerList(speakerList) {
    speakerList.forEach(speaker => {
      speaker['MT_speakers'].forEach(mt_speaker => {
        if (mt_speaker['SP_approval']) {
          mt_speaker['MT_title'] = speaker['MT_title'];
          mt_speaker['MT_date'] = speaker['MT_date'];
          mt_speaker['MT_statcat'] = speaker['MT_statcat'];
          mt_speaker['MT_cluster'] = speaker['MT_cluster'];
          mt_speaker['MT_agendaitem'] = speaker['MT_agendaitem'];
          if (mt_speaker.SP_endtime && mt_speaker.SP_endtime !== '' || mt_speaker.SP_isDone) {
            this.spokenSpeakerList.push(mt_speaker);
          }
          if (!mt_speaker.SP_endtime && !mt_speaker.SP_isDone) {
            this.futureSpeakerList.push(mt_speaker);
          }
        }
      });
      this.sortSpeakerList(this.spokenSpeakerList);
      this.sortSpeakerList(this.futureSpeakerList);
    });
  }

  ngOnDestroy(): void {
    clearInterval(this.intervalId);
  }

  sortSpeakerList(speakerList) {
    speakerList.sort((a, b) => {
      if (a['MT_title'] === b['MT_title']) {
        if (a['MT_agendaitem']['MT_AG_item'] === b['MT_agendaitem']['MT_AG_item']) {
          if (a['MT_cluster']['MT_clusterName'] === b['MT_cluster']['MT_clusterName']) {
            if (a['MT_statcat'] === b['MT_statcat']) {
              return a['SP_slotNo'] - b['SP_slotNo'];
            } else {
              return a['MT_statcat'] > b['MT_statcat'] ? 1 : -1;
            }
          } else {
            return a['MT_cluster']['MT_clusterName'] > b['MT_cluster']['MT_clusterName'] ? 1 : -1;
          }
        } else {
          return a['MT_agendaitem']['MT_AG_item'] > b['MT_agendaitem']['MT_AG_item'] ? 1 : -1;
        }
      } else {
        return a['MT_title'] > b['MT_title'] ? 1 : -1;
      }
    });
  }

  // Background
  greyedOutCheck(speaker) {
    return speaker['SP_endtime'] || speaker['SP_isDone'] || speaker['SP_isSkip'];
  }

  setHeaderAttributes(windowWidth) {
    if (windowWidth < 992) {
      this.navRight = 'nav-off';
    } else {
      this.navRight = 'nav-on';
    }
  }

  onResize(event) {
    this.windowWidth = event.target.innerWidth;
    this.setHeaderAttributes(this.windowWidth);

    let reSizeFlag = true;
    if (this.pcodedDeviceType === 'tablet' && this.windowWidth >= 768 && this.windowWidth <= 1024) {
      reSizeFlag = false;
    } else if (this.pcodedDeviceType === 'phone' && this.windowWidth < 768) {
      reSizeFlag = false;
    } else {
      reSizeFlag = true;
    }
    /* for check device */
    if (reSizeFlag) {
      this.setMenuAttributes(this.windowWidth);
    }
  }

  setMenuAttributes(windowWidth) {
    if (windowWidth >= 768 && windowWidth <= 1024) {
      this.pcodedDeviceType = 'tablet';
      this.verticalNavType = 'offcanvas';
      this.verticalEffect = 'overlay';
      this.toggleIcon = 'icon-toggle-left';
      this.headerFixedTop = '50px';
    } else if (windowWidth < 768) {
      this.pcodedDeviceType = 'phone';
      this.verticalNavType = 'offcanvas';
      this.verticalEffect = 'overlay';
      this.toggleIcon = 'icon-toggle-left';
    } else {
      this.pcodedDeviceType = 'desktop';
      this.verticalNavType = 'expanded';
      this.verticalEffect = 'shrink';
      this.toggleIcon = 'icon-toggle-right';
    }
  }

  setBackgroundPattern(pattern: string) {
    document.querySelector('body').setAttribute('themebg-pattern', pattern);
  }

  setupLanguage(language) {
    this.language = language;
  }

  LORCheck(speaker) {
    if (
      !speaker.SP_LS_lvlRepr
      || (speaker.SP_LS_lvlRepr && !speaker.SP_LS_lvlRepr.SP_LS_lvlReprShort)
      || ['CD', 'PR', 'HL'].indexOf(speaker.SP_LS_lvlRepr.SP_LS_lvlReprShort) !== -1
    ) {
      return false;
    } else {
      return true;
    }


  }
  printExcel(){
      const modalRef = this.modal.open(SelectCountryComponent, {size: 'lg', windowClass: 'modal-xl', backdrop : 'static',
      keyboard : false});
      var countries=[];
     this.splittedData["country"]['1'].forEach(element=>{
       countries.push(element);
     })
   this.splittedData["country"]['2'].forEach(element=>{
      countries.push(element);
    })
    this.splittedData["country"]['4'].forEach(element=>{
      countries.push(element);
    })
    this.splittedData["country"]['5'].forEach(element=>{
      countries.push(element);
    })
    this.splittedData["country"]['6'].forEach(element=>{
      countries.push(element);
    })
      modalRef.componentInstance.countries = countries;

      modalRef.result.then((result) => {
        if (result) {
        console.log(result);
        var cntry=result.mission;
        var category=result.category;
        var representativeList=[];
      //  this.mission=cntry;
        this.changeMissionExcel(cntry,category);
       // this.updateDelegate();
       this.generateExcelService.generateExcel(cntry,this.representativeListExcel);
      }
        });
    
  }
  printXml() {
  this.generateXmlService.generateXml(this.splittedData);
    
}


}





// WEBPACK FOOTER //
// ./src/app/app.component.ts